module.exports = __webpack_public_path__ + "img/approved.71bf0f04.svg";